import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
  GlameraIconBase,
  GlameraIconDefinition,
  GLAMERA_ICON_HOST_TEMPLATE,
} from '@glamera/animated-icons/core';

export const GLM_CHEVRON_LEFT: GlameraIconDefinition = {
  name: 'chevron-left',
  viewBox: '0 0 24 24',
  svg: `
    <path class="glm-chevron-left-trail" d="m15 18-6-6 6-6"></path>
    <path class="glm-chevron-left-arrow" d="m15 18-6-6 6-6"></path>
  `.trim(),
};

@Component({
  standalone: true,
  selector: 'glamera-chevron-left-icon',
  template: GLAMERA_ICON_HOST_TEMPLATE,
  styleUrls: ['../../core/src/lib/base/icon-base.scss', './chevron-left.animation.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class ChevronLeftIconComponent extends GlameraIconBase {
  readonly iconDef = GLM_CHEVRON_LEFT;

  constructor(sanitizer: DomSanitizer, cdr: ChangeDetectorRef) {
    super(sanitizer, cdr);
  }
}
